import { render } from "./InsightCard.vue?vue&type=template&id=796f1b75&scoped=true"
import script from "./InsightCard.vue?vue&type=script&lang=js"
export * from "./InsightCard.vue?vue&type=script&lang=js"

import "./InsightCard.vue?vue&type=style&index=0&id=796f1b75&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796f1b75"]])

export default __exports__